import { useHasPermission } from './useHasPermission';

export const useIsUnitManager = () => {
  const hasAdminAccess = useHasPermission('ADMIN_ACCESS');
  const hasUnitManagerAccess = useHasPermission('UNIT_EMPLOYEES_EDIT');

  return hasUnitManagerAccess && !hasAdminAccess;
};
